"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _eventBus = require("@/helpers/event-bus.js");

var _InfosAffaireTop = _interopRequireDefault(require("./components/InfosAffaireTop"));

var _InfosAffaireBottom = _interopRequireDefault(require("./components/InfosAffaireBottom"));

var _venteInitiale = _interopRequireDefault(require("../venteInitiale"));

var _objectifs = _interopRequireDefault(require("../objectifs"));

var _historique = _interopRequireDefault(require("../historique"));

var _budgetAffaire = _interopRequireDefault(require("../budgetAffaire"));

var _gestmensuelle = _interopRequireDefault(require("../gestmensuelle"));

var _synthesemensuelle = _interopRequireDefault(require("../synthesemensuelle"));

var _avenants = _interopRequireDefault(require("../avenants"));

var _avenants_tsuppl = _interopRequireDefault(require("../avenants_tsuppl"));

var _avenants_mprinc = _interopRequireDefault(require("../avenants_mprinc"));

var _budgetsComp = _interopRequireDefault(require("../budgetsComp"));

var _provisions = _interopRequireDefault(require("../provisions"));

var _provisionsRisques = _interopRequireDefault(require("../provisionsRisques"));

var _transferts = _interopRequireDefault(require("../transferts"));

var _CommandeModule = _interopRequireDefault(require("../commandes/CommandeModule"));

var _FactureModule = _interopRequireDefault(require("../factures/FactureModule"));

var _ReglementModule = _interopRequireDefault(require("../reglements/ReglementModule"));

var _commentaire = _interopRequireDefault(require("../commentaire"));

var _debug = _interopRequireDefault(require("../debug"));

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var apiHistorique = _interopRequireWildcard(require("@/api/historique"));

var _utils = require("@/helpers/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  // 1. Effets de bord
  // --
  // 2. Informations globales
  // --
  name: 'ViewAffaire',
  // 3. Type de composant
  // --
  // 4. Modificateurs de template
  // --
  // 5. Dépendances des templates
  // --
  components: {
    InfosAffaireTop: _InfosAffaireTop.default,
    InfosAffaireBottom: _InfosAffaireBottom.default,
    VenteInitiale: _venteInitiale.default,
    Objectifs: _objectifs.default,
    Historique: _historique.default,
    BudgetAffaire: _budgetAffaire.default,
    GestMensuelle: _gestmensuelle.default,
    Avenants: _avenants.default,
    AvenantsTravauxSuppl: _avenants_tsuppl.default,
    AvenantsMarchePrinc: _avenants_mprinc.default,
    BudgetsComp: _budgetsComp.default,
    Provisions: _provisions.default,
    ProvisionsRisques: _provisionsRisques.default,
    Transferts: _transferts.default,
    Commentaire: _commentaire.default,
    CommandeModule: _CommandeModule.default,
    FactureModule: _FactureModule.default,
    ReglementModule: _ReglementModule.default,
    Debug: _debug.default,
    SynthMensuelle: _synthesemensuelle.default
  },
  // 6. Composition
  // --
  // 7. Interface (interface du composant)
  // --
  // 8. État local (propriétés réactives locales)
  // --
  data: function data() {
    return {
      refresh: 0,
      modeEditCounter: 0,
      id_commande: null,
      id_facture: null,
      loading: false,
      showMenu: false,
      activeMenu: 'informations',
      CONST: CONST,
      allPeriodeGestMens: [],
      currentPeriodeGestMens: '',
      periodeGestionMMMMYYYY: '',
      tabmenus: [{
        key: 'informations',
        path: [{
          key: 'information',
          title: 'Informations'
        }]
      }, {
        key: 'venteInitiale',
        path: [{
          key: 'venteInitiale',
          title: 'Vente initiale'
        }]
      }, {
        key: 'objectifsDebourses',
        path: [{
          key: 'objectifsDebourses',
          title: 'Objectifs déboursés'
        }]
      }, {
        key: 'budgetAffaire',
        path: [{
          key: 'Budget affaire',
          title: 'Budget affaire'
        }]
      }, {
        key: 'gestionMensuelle',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }]
      }, {
        key: 'syntheseMensuelle',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'syntheseMensuelle',
          title: 'Synthese mensuelle'
        }]
      }, {
        key: 'avenants',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'avenants',
          title: 'Avenants'
        }]
      }, {
        key: 'avenants_travaux_suppl',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'avenants',
          title: 'Avenants'
        }, {
          key: 'avenants_travaux_suppl',
          title: 'Avenants travaux supplémentaires'
        }]
      }, {
        key: 'avenants_marche_princ',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'avenants',
          title: 'Avenants'
        }, {
          key: 'avenants_marche_princ',
          title: 'Avenants au marché principal'
        }]
      }, {
        key: 'budgetscomp',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'budgetscomp',
          title: 'Budgets complémentaires'
        }]
      }, {
        key: 'provisions',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'provisions',
          title: 'Aléas'
        }]
      }, {
        key: 'provisions-risques',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'provisions-risques',
          title: 'Provisions'
        }]
      }, {
        key: 'transferts',
        path: [{
          key: 'gestionMensuelle',
          title: 'Gestion mensuelle'
        }, {
          key: 'transferts',
          title: 'Transferts'
        }]
      }, {
        key: 'commentaire',
        path: [{
          key: 'commentaire',
          title: 'Commentaires'
        }]
      }, {
        key: 'commandes',
        path: [{
          key: 'facturation',
          title: 'Facturation',
          redirect: 'noRedirect'
        }, {
          key: 'commandes',
          title: 'Commandes'
        }]
      }, {
        key: 'factures',
        path: [{
          key: 'facturation',
          title: 'Facturation',
          redirect: 'noRedirect'
        }, {
          key: 'factures',
          title: 'Factures'
        }]
      }, {
        key: 'factures_by_commande',
        path: [{
          key: 'facturation',
          title: 'Facturation',
          redirect: 'noRedirect'
        }, {
          key: 'commandes',
          title: 'Commandes'
        }, // { key: 'commande_list', title: 'Commandes', redirect: 'noRedirect' },
        {
          key: 'factures_by_commande',
          title: '__NUMERO_COMMANDE__',
          redirect: 'noRedirect'
        }, {
          key: 'facture_list',
          title: 'Factures'
        }]
      }, {
        key: 'reglements',
        path: [{
          key: 'facturation',
          title: 'Facturation',
          redirect: 'noRedirect'
        }, {
          key: 'reglements',
          title: 'Règlements'
        }]
      }, {
        key: 'reglements_by_facture',
        path: [{
          key: 'facturation',
          title: 'Facturation',
          redirect: 'noRedirect'
        }, {
          key: 'commandes',
          title: 'Commandes'
        }, // { key: 'commande_list', title: 'Commandes', redirect: 'noRedirect' },
        {
          key: 'factures_by_commande',
          title: '__NUMERO_COMMANDE__',
          args: null
        }, {
          key: 'facture_list',
          title: 'Factures',
          redirect: 'noRedirect'
        }, {
          key: 'reglements_by_facture',
          title: '__NUMERO_FACTURE__',
          redirect: 'noRedirect'
        }, {
          key: 'reglements',
          title: 'Règlements'
        }]
      }, {
        key: 'historique',
        path: [{
          key: 'historique',
          title: 'Historique'
        }]
      }, {
        key: 'debug',
        path: [{
          key: 'debug',
          title: 'Debug'
        }]
      }],
      showPeriode: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['notifications', 'user']), {}, (0, _vuex.mapGetters)('facturation', ['getFacturationSoldee']), {
    status: function status() {
      var caption = '';
      var extra = '';

      switch (this.affaire.status) {
        case CONST.AFFAIRE.STATUS.SLEEPING.value:
          caption = CONST.AFFAIRE.STATUS.SLEEPING.title + ' | Gestion mensuelle du ';
          break;

        case CONST.AFFAIRE.STATUS.ARCHIVED.value:
          caption = CONST.AFFAIRE.STATUS.ARCHIVED.title + ' | Gestion mensuelle du ';
          break;

        case CONST.AFFAIRE.STATUS.CLOSED.value:
          caption = CONST.AFFAIRE.STATUS.CLOSED.title + ' | Gestion mensuelle du ';
          break;

        case CONST.AFFAIRE.STATUS.DRAFT.value:
          caption = CONST.AFFAIRE.STATUS.DRAFT.title;
          break;

        case CONST.AFFAIRE.STATUS.TOVALIDATE.value:
        case CONST.AFFAIRE.STATUS.TOVALIDATE1.value:
        case CONST.AFFAIRE.STATUS.TOVALIDATE2.value:
          caption = 'En attente de validation';
          break;

        case CONST.AFFAIRE.STATUS.DENIED.value:
        case CONST.AFFAIRE.STATUS.DENIED1.value:
        case CONST.AFFAIRE.STATUS.DENIED2.value:
          caption = 'Refusé';
          break;

        default:
          caption = 'En cours';
      }

      var cond = [CONST.AFFAIRE.STATUS.CLOSED.value, CONST.AFFAIRE.STATUS.SLEEPING.value, CONST.AFFAIRE.STATUS.ARCHIVED.value].includes(this.affaire.status);

      if (!cond) {
        switch (this.affaire.etape) {
          case CONST.AFFAIRE.ETAPE.VENTE_INITIALE.value:
            caption += ' | Vente initiale';
            break;

          case CONST.AFFAIRE.ETAPE.OBJECTIF_DEBOURSE.value:
            caption += ' | Objectifs déboursés';
            break;

          case CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value:
            caption += ' | Budget affaire';
            break;

          case CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value:
            var periode = this.allPeriodeGestMens[0] && this.allPeriodeGestMens[0].value;

            if (this.currentPeriodeGestMens === periode) {
              caption += ' | En gestion ';
            } else {
              caption = 'Gestion mensuelle du ';
            }

            break;
        }
      }

      return {
        caption: caption,
        extra: extra
      };
    },
    affaire: function affaire() {
      return this.$store.getters.affaire.affaire;
    },
    highlightedActiveMenu: function highlightedActiveMenu() {
      var highlightedActiveMenu = '';

      switch (this.activeMenu) {
        // case 'factures_by_commande':
        // case 'reglements_by_facture':
        //   highlightedActiveMenu = 'facturation'
        //   break
        case 'factures_by_commande':
          highlightedActiveMenu = 'factures';
          break;

        case 'reglements_by_facture':
          highlightedActiveMenu = 'reglements';
          break;

        default:
          highlightedActiveMenu = this.activeMenu;
          break;
      }

      return highlightedActiveMenu;
    }
  }),
  // 9. Évènements
  // --
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this = this;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _eventBus.EventBus.$on('MODE_EDIT', function (modeEdit) {
                if (modeEdit === -1) {
                  modeEdit = false;
                }

                _this.$root.modeEdit = modeEdit;
              });

              _eventBus.EventBus.$on('REFRESH_CALCULS', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                var params,
                    filtreProvisions,
                    _args2 = arguments;
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                        _this.showPeriode = false;
                        params.periode = _this.currentPeriodeGestMens;
                        params.modeEdit = _this.$root.modeEdit;
                        console.log('REFRESH_CALCULS (app/affaire/view.vue)', _this.activeMenu, 'modeEdit = ', _this.$root.modeEdit);
                        filtreProvisions = (0, _utils.getFiltreProvisionsByEcran)(_this.activeMenu); // cf @/helpers/utils.js

                        _context2.next = 8;
                        return _this.$store.dispatch('affaire/calcul', {
                          params: params,
                          filtreProvisions: filtreProvisions
                        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                          return _regenerator.default.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return _this.getAllPeriodeGestMens();

                                case 2:
                                  _eventBus.EventBus.$emit('REFRESH', params);

                                case 3:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        })));

                      case 8:
                        _this.showPeriode = true;

                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));

              _eventBus.EventBus.$on('TAB_MENU', function (key, row) {
                console.log('Changement de menu', key);
                _this.activeMenu = key;

                _this.setBreadcrumb(key);

                var menu = null;
                var path = null;

                switch (key) {
                  // Personnalisation du Breadcrumb pour les factures d'une commande
                  case 'factures_by_commande':
                    var commande = row;

                    if (commande === undefined) {
                      return;
                    } // MAJ de l'id de la commande parente


                    _this.id_commande = commande ? commande.id : null; // Trouver le menu ayant pour clé 'factures_by_commande'

                    menu = _this.tabmenus.find(function (x) {
                      return x.key === 'factures_by_commande';
                    });

                    if (menu) {
                      // Trouver le sous-menu ayant pour clé 'factures_by_commande'
                      path = menu.path.find(function (x) {
                        return x.key === 'factures_by_commande';
                      });

                      if (path) {
                        if (commande) {
                          path.title = commande.numero;
                          path.args = commande;
                        } else {
                          path.title = 'Aucune commande';
                          path.args = null;
                          path.redirect = 'noRedirect';
                        }
                      }
                    }

                    break;
                  // Personnalisation du Breadcrumb pour les règlements d'une facture

                  case 'reglements_by_facture':
                    var facture = row;

                    if (facture === undefined) {
                      return;
                    } // MAJ de l'id de la commande parente


                    _this.id_commande = facture.commande ? facture.commande.id : null; // MAJ de l'id de la facture parente

                    _this.id_facture = facture.id; // Trouver le menu ayant pour clé 'reglements_by_facture'

                    menu = _this.tabmenus.find(function (x) {
                      return x.key === 'reglements_by_facture';
                    });

                    if (menu) {
                      // Trouver le sous-menu ayant pour clé 'factures_by_commande'
                      path = menu.path.find(function (x) {
                        return x.key === 'factures_by_commande';
                      });

                      if (path) {
                        // Si une commande parente existe
                        if (facture.commande) {
                          path.title = facture.commande.numero;
                          path.args = facture.commande;
                          path.redirect = null;
                        } else {
                          path.title = 'Aucune commande';
                          path.args = null;
                          path.redirect = 'noRedirect';
                        }
                      } // Trouver le sous-menu ayant pour clé 'reglements_by_facture'


                      path = menu.path.find(function (x) {
                        return x.key === 'reglements_by_facture';
                      });

                      if (path) {
                        path.title = facture.numero;
                        path.args = facture;
                      }
                    }

                    break;
                }
              });

              _context3.next = 5;
              return this.loadAffaire();

            case 5:
              _context3.next = 7;
              return this.setBreadcrumb('informations');

            case 7:
              _eventBus.EventBus.$emit('REFRESH_CALCULS');

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('REFRESH_CALCULS');

    _eventBus.EventBus.$off('TAB_MENU');

    this.$store.dispatch('app/tabmenu', '');
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this2 = this;

      var notifs, index;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // si l'utilisateur connecté qui consulte l'affaire a une notification sur cette affaire
              // on marque la notification comme lue
              notifs = this.notifications.notifications;
              index = notifs.findIndex(function (e, indx) {
                // recherche de la notification et retour de l'index de tableau
                return e.id_user === _this2.user.id && e.url_link === '/#/affaire/' + _this2.$route.params.id && e.date_markasread === null;
              });

              if (index >= 0) {
                this.$store.dispatch('notifications/markasread', notifs[index]);
              }

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  // 10. Propriétés non réactives
  // --
  methods: {
    canEdit: function canEdit() {
      var affaire = this.$store.getters.affaire;
      var cond1 = affaire.YYYYMM === affaire.histoLastGestMens && affaire.histoLastGestMens && affaire.YYYYMM === affaire.lastGestMens;
      var cond2 = [CONST.AFFAIRE.STATUS.CLOSED.value, CONST.AFFAIRE.STATUS.SLEEPING.value, CONST.AFFAIRE.STATUS.ARCHIVED.value].includes(affaire.affaire.status);
      return affaire.YYYYMM ? cond1 && !cond2 : true;
    },
    loadAffaire: function () {
      var _loadAffaire = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this3 = this;

        var idAffaire;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.showMenu = false;
                this.$loader(true);
                idAffaire = this.$route.params.id;
                _context5.next = 5;
                return this.$store.dispatch('affaire/getAffaireById', idAffaire).then(function (result) {
                  _this3.$loader(false);

                  _this3.showMenu = true;
                }).catch(function () {
                  _this3.$router.push('/affaire');

                  _this3.$loader(false);

                  _this3.showMenu = false;
                });

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadAffaire() {
        return _loadAffaire.apply(this, arguments);
      }

      return loadAffaire;
    }(),
    periodeGestion: function periodeGestion() {
      _moment.default.locale('fr');

      var periode = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM').format('MMMM YYYY');
      var isValidDate = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM', true).isValid();
      return this.$store.getters.affaire.currentGestMensYYYYMM && isValidDate ? 'Gestion de ' + periode : '';
    },
    isDisabled: function isDisabled(status) {
      return this.affaire.etape < status && this.affaire.status !== CONST.AFFAIRE.STATUS.CLOSED.value && !this.affaire.periode_gestmens;
    },
    getAllPeriodeGestMens: function () {
      var _getAllPeriodeGestMens = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _this4 = this;

        var results;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return apiHistorique.getAllPeriodeGestMensByAffaireId(this.$route.params.id);

              case 2:
                results = _context6.sent;
                this.allPeriodeGestMens = [];
                results.forEach(function (x) {
                  var label = (0, _moment.default)(x.YYYYMM, 'YYYYMM').subtract(1, 'months').format('MM/YYYY'); // pour faire coincer avec l'affichage au dessus du n° d'affaire dans le haut de la page

                  _this4.allPeriodeGestMens.push({
                    value: x.YYYYMM,
                    label: label
                  });
                });
                this.currentPeriodeGestMens = this.$store.getters.affaire.YYYYMM;

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAllPeriodeGestMens() {
        return _getAllPeriodeGestMens.apply(this, arguments);
      }

      return getAllPeriodeGestMens;
    }(),
    handleChangePeriodeGestMens: function handleChangePeriodeGestMens() {
      if (this.$root.modeEdit) {
        if (!confirm('Les modifications que vous avez apportées ne seront peut-être pas enregistrées. Voulez-vous continuer ?')) {
          this.currentPeriodeGestMens = this.$store.getters.affaire.YYYYMM;
          return;
        }
      }

      _eventBus.EventBus.$emit('MODE_EDIT', false);

      _eventBus.EventBus.$emit('REFRESH_CALCULS');

      this.$store.getters.affaire.selection = this.$store.getters.affaire.YYYYMM;
    },
    handleMenuSelect: function handleMenuSelect(key, keyPath) {
      // if (this.modeEditCounter > 0) {
      if (this.$root.modeEdit) {
        if (!confirm('Les modifications que vous avez apportées ne seront peut-être pas enregistrées. Voulez-vous continuer ?')) {
          this.$refs.ElMenu.activeIndex = this.activeMenu;
          return;
        }
      }

      _eventBus.EventBus.$emit('MODE_EDIT', false);

      this.activeMenu = key;
      this.setBreadcrumb(key);
    },
    setBreadcrumb: function setBreadcrumb(key) {
      var menu = this.tabmenus.find(function (x) {
        return x.key === key;
      });

      if (menu) {
        this.$store.dispatch('app/tabmenu', menu);
      } // Actions spécifiques en fonction de l'item de menu cliqué


      switch (key) {
        // Affichage de tous les réglements de l'affaire
        case 'reglements':
          // On retire les filtres de données
          this.id_commande = null;
          this.id_facture = null;
          break;
        // Affichage de toutes les factures de l'affaire

        case 'factures':
          // On retire les filtres de données
          this.id_commande = null;
          break;
      }
    }
  } // 11. Rendu
  // --

};
exports.default = _default;